<!--Goes through the blogs and doc listings to present and renders the objects.-->

<template>
  <mdbCol lg="4" md="6" class="py-5 px-2">  <!-- Want this to size differently on ipad...-->
    <recent_blog
      v-if="!loading && (page_type == 'blog.DepartmentBlogListingPage' || page_type == 'blog.BlogListingPage')"
      :parent_page="page"
      :title="block.value.title"
      :img="block.value.heading_image.original.src"
    />
    <!-- <recent_docs
      v-if="!loading && page_type == 'departments.DepartmentDocumentListingPage'"
      :parent_page="page"
      :title="block.value.title"
    />-->
  </mdbCol>
</template>

<script>
import { mdbCol } from "mdbvue";
import axios from "axios";
import api from "@/api"
import recent_blog from "@/components/streamfields/recent_items/recent_blog.vue";
//import recent_docs from "@/components/streamfields/recent_items/recent_docs.vue";

export default {
  name: "recent_items_block",
  components: {
    mdbCol,
    recent_blog
    //recent_docs
  },
  props: {
    block: Object,
    page_id: Number,
  },
  data() {
    return {
      loading: true,
      page: false,
      page_type: false
    };
  },
  computed: {
    axiosParams() {
      const params = new URLSearchParams();
      params.append("fields", "*");
      return params;
    }
  },
  methods: {
    getData() {
      axios
        api.get("pages/" + this.page_id, {
          params: this.axiosParams
        })
        .then(response => {
          this.page = response.data;
          this.page_type = this.page.meta.type;
        })
        .catch(e => {
          this.errors.push(e);
        })
        .finally(() => (this.loading = false));
    },
    clearSearch() {
      this.searchQuery = "";
    },
    extractParentSlug: function() {
      /* Retrieves slug of DepartmentLandingPage which is parent to this page. */

      var parent_html_url = this.documentListing.meta.parent.meta.html_url;
      var url_ary = parent_html_url.split("/");
      var slug = url_ary[url_ary.length - 2];
      this.parentSlug = slug;
    },
  },
  mounted() {
    this.getData();
  }
};
</script>